var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TradePanel',{attrs:{"title":_vm.title}},[_c('AskBidPrices',{attrs:{"stock":_vm.stock,"context":"trade"}}),_vm._v(" "),_c('TradeStatus'),_vm._v(" "),(_vm.tradeRequest.order)?_c('OrderForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }